import React from 'react'
import {Col, Form, Row} from 'rsuite'
import {RichTextBlock, RichTextBlockValue} from '@dudagroup/editor'
import {ContentModelSchemaFieldRichText} from '@dudagroup/api'
import {I18n} from '../interfaces/interfaces'
import {getEmptyRichText} from '../utility'

interface SlateReferenceProps {
  /** The retired Slate field from the block's model, `legacySlate()` in the API. */
  field: ContentModelSchemaFieldRichText | undefined
  value: I18n<RichTextBlockValue> | undefined
  languageContext: React.ComponentProps<typeof RichTextBlock>['languageContext']
}

/**
 * The frozen Slate value of a rich-text field, read-only, under its TipTap
 * editor, for comparing the migration (RESNF-752). The API hides the Slate
 * field unless `SHOW_RICHTEXT_SOURCE` is set (dev and staging), and this pane
 * follows that setting, so production shows TipTap only.
 */
export function SlateReference({field, value, languageContext}: SlateReferenceProps) {
  if (!field || field.editor?.hidden || !value) return null

  const lane = (lang: string) => (
    <RichTextBlock
      languageContext={languageContext}
      config={field.config}
      value={value[lang] || getEmptyRichText('')}
      onChange={() => {
        // read-only reference
      }}
      autofocus={false}
      displayOnly={true}
      disabled={true}
    />
  )

  return (
    <>
      <Form.ControlLabel style={{fontWeight: 700}}>Slate (alt, nur Ansicht)</Form.ControlLabel>
      <Row className="show-grid" style={{display: 'flex', alignItems: 'top', marginBottom: 24}}>
        <Col xs={14} style={{padding: 0}}>
          {lane(languageContext.langLane1)}
        </Col>
        <Col xs={1} style={{textAlign: 'center', paddingTop: '5px'}}></Col>
        <Col xs={9}>{lane(languageContext.langLane2)}</Col>
      </Row>
    </>
  )
}
